import React from 'react';
import { PageLayout } from '../components/PageLayout';
import { ComingSoon } from '../components/ComingSoon';
export function PolicePistolMatchPage() {
  return <PageLayout data-id="element-2521">
      <ComingSoon title="FLSC Police Pistol Combat Match" breadcrumb="Featured Event" data-id="element-2522" />
    </PageLayout>;
}